export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5328.a3b0f63a.jpg";